<!-- Simplified Header -->
<mat-toolbar>
    <div>
        <!-- You can add an icon if you like -->
        <mat-icon style="vertical-align: middle; margin-right: 8px;">auto_awesome</mat-icon>
        <span style="vertical-align: middle;">AI Chat Assistant</span>
    </div>
    <!-- Optional: Add a clear chat button if implemented -->
    <span fxFlex></span> <!-- Pushes button to the right -->
    <div style="position: relative; top: -2px">
        <div style="display: flex; align-items: center;">
            <button mat-icon-button matTooltip="Clear Chat" (click)="clearChat()">
                <mat-icon>delete</mat-icon>
            </button>
            <button mat-icon-button matTooltip="{{'general.downloadTranscript' | transloco}}" (click)="downloadChat()">
                <mat-icon>download</mat-icon>
            </button>
        </div>
    </div>

</mat-toolbar>

<!-- Main Chat Area -->
<div class="chatApp">
    <div class="main-container">
        <div class="chat-wrapper">
            <!-- Use a template reference variable #chatContainer -->
            <div class="itemTableWrapCustomer" #chatContainer id="container1">
                <mat-list id="container2">
                    <!-- Loop through simplified messages -->
                    @for (conv of m_conversations; track $index) {
                        <!-- Use $index if no unique id -->
                        <mat-list-item id="container3" class="messageEntry">
                            <!-- Use 'assistant' role for the right side -->
                            @if (conv.role === 'customer') {
                                <div class="textAlignLeftChat customerMessage">
                            <span class="chatConversationTime">
                                {{ conv.time | date:'MM-dd-yy hh:mm:ss a' }} | You <!-- Use Angular DatePipe -->
                            </span><br/>
                                    <!-- Use safe pipe for potential HTML in messages -->
                                    <span class="chatConversation" [innerHTML]="conv.body | pipeSafe:'html'"></span>
                                </div>
                            }
                            @if (conv.role === 'assistant') {
                                <div class="textAlignRightChat supportMessage">
                            <span class="chatConversationTime">
                                {{ conv.time | date:'MM-dd-yy hh:mm:ss a' }} | Assistant <!-- Use Angular DatePipe -->
                            </span><br/>
                                    <span class="chatConversation" [innerHTML]="conv.body | pipeSafe:'html'"></span>
                                </div>
                            }
                        </mat-list-item>
                    } @empty {
                        <!-- Optional: Show something when chat is empty -->
                        <p style="text-align: center; padding: 20px; color: grey;">No messages yet.</p>
                    }
                </mat-list>
                @if (isLoading) {
                    <div style="text-align: center; padding: 20px;">
                        <app-loading [type]="-1" [size]="'60px'" [style]="{'margin-top': '5px'}"></app-loading>
<!--                        <mat-icon style="vertical-align: middle; margin-right: 8px;">auto_awesome</mat-icon>-->
                        <div class="text-center" style="padding-top: 20px">
                            <span flashlightText style="font-size: 1.1em; font-weight: bold">thinking...</span>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>

    <!-- Input Toolbar -->
    <mat-toolbar color="primary" style="height: auto; min-height: 64px; padding-top: 5px; padding-bottom: 5px;"> <!-- Adjust height as needed -->
        <div class="chat-controls" fxLayout="row" fxFill fxLayoutAlign="center center">
            <mat-form-field class="userEnterText" appearance="outline" style="width: 100%; margin-right: 8px;"> <!-- Use outline or other appearance -->
                <mat-label>{{ 'placeholder.enterText' | transloco }}</mat-label>
                <input #txtMain
                       matInput type="text"
                       [disabled]="isLoading"
                       (keydown.enter)="sendMessage()"
                       [(ngModel)]="m_messageModel"
                       placeholder="type your question here..."
                       autocomplete="off"/>
                <!-- Optional: Add error icon -->
                @if (errorOccurred) {
                    <mat-icon matSuffix color="warn">error_outline</mat-icon>
                }
            </mat-form-field>
            <button mat-fab extended color="accent" [disabled]="isLoading || !m_messageModel.trim()" class="userButtons" (click)="sendMessage()" type="button" matTooltip="{{'general.send' | transloco}}">
                <mat-icon>send</mat-icon>
                Send
            </button>
            <!-- Removed other buttons like emoji, disconnect, popup, ring -->
        </div>
    </mat-toolbar>
</div>
